/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end

// redio audio popup start

function play_redio_audio() {  
  if(localStorage.getItem("redio_popup") == 'play'){

    
   const radioButton = document.querySelector('[data-header-audio]') || null;
   const videoIframe = document.getElementById('videoIframe') || null;
    
          if (radioButton && videoIframe) {
             const videoUrl = radioButton.getAttribute('href');
              console.log(videoUrl);
            videoIframe.src = ''
            videoIframe.src = videoUrl; // Set the video URL in iframe
          }
  }
}

// redio audio popup play end


// CUSTOM PAGINATION START VK

function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
// if(window.location.href.includes('?page=')){
// window.location.replace(window.location.href.split('?')[0]);
// }

 // if(document.body.classList.contains('template-collection') || document.body.classList.contains('template-blog')){
 //    if(window.location.href.includes('?page=')){
 //      window.location.replace(window.location.href.split('?')[0]);
 //    }
 //  }

function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-main-pagination-data]");
    if(proGrid){
      // replace grid 
      // console.log(html.querySelector("[data-main-pagination-data]"))
      proGrid.innerHTML = document.querySelector("[data-main-pagination-data]").innerHTML + html.querySelector("[data-main-pagination-data]").innerHTML;
      // replace pagination
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); 
      let pagination = document.querySelector("page-pagination");
      let newPagination = html.querySelector("page-pagination");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
      }
      pagination_click_fun();
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}
// CUSTOM PAGINATION END VK



(function() {

faq_taggol();  

  newsletter_mail();


  const noty_fy = document.querySelector("[data-custom-notify-btn]") || null;
if(noty_fy){
    noty_fy.addEventListener("click", function(event) {
       event.preventDefault();
            const main_popup = document.querySelector(event.target.hash) || null;
        if(main_popup){
               main_popup.classList.add("notify-form-open");
              document.body.classList.add("popup_open");
        }
    })
}

 const popup_close = document.querySelectorAll("[data-popup-close]") || null;
if(popup_close){
     popup_close.forEach(b => {
        b.addEventListener("click", event => {
            event.preventDefault();
            const main_popup = event.target.closest("[data-poup]") || null;
            main_popup && (main_popup.classList.remove("notify-form-open"),
            document.body.classList.remove("popup_open"))
        });
     });
}
  

const header_overlay = document.querySelector("[data-banner-header-overlay_trans]") || null;
  if(header_overlay){
    document.body.classList.add('header-overlay');
  }    
// const header_operlay = document.querySelector("[data-banner-header-overlay]");
//   if(header_operlay){
//     document.body.classList.add('header-overlay');
//   }

  if(!document.body.classList.contains('template-index')){
   const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(!header_operlay){
    document.body.classList.remove('header-overlay');
  }
  }



  const revier_tragger = document.querySelectorAll('[data-review-tragger]') || null;
  if(revier_tragger){

      revier_tragger.forEach((tragger) => {
    const intro = document.querySelector(".ruk_rating_snippet") || null;
    if(intro){
        tragger.onclick = (e) => {
          e.preventDefault();
           intro.click();
        };
    }
  }); 
    
  }


  const mobile_blog = document.querySelector('[data-toggle-mobile-blog]') || null;
  if(mobile_blog){
   const mobile_blog_tragger =  mobile_blog.querySelectorAll('[data-mobile-toggle] a') || null;
    if(mobile_blog_tragger){
            mobile_blog_tragger.forEach(b => {
                    b.addEventListener("click", event => {
                       if(event.target.classList.contains("text--underlined")){
                        event.preventDefault();                      
                        mobile_blog.classList.toggle("open-dropdown");
                       }
                    });
                });
    }
}
  



  // audio popup

 const radioButton = document.querySelector('[data-header-audio]') || null;
 const videoIframe = document.getElementById('videoIframe') || null;
 const modal = document.getElementById('videoModal') || null;
const closeButton = document.querySelectorAll('[data-header-audio-close]') || null;;
  if (radioButton && videoIframe) {
    radioButton.addEventListener('click', function (event) {
      event.preventDefault();
      const videoUrl = radioButton.getAttribute('href');
        // console.log(videoUrl);
      videoIframe.src = ''
      videoIframe.src = videoUrl; // Set the video URL in iframe
        if(modal) modal.style.display = 'flex'; // Show the modal
       document.body.classList.add("popup_open");
      localStorage.setItem("redio_popup", "play");
    });
  }
  if(closeButton){
     closeButton.forEach(closebtn => {
           closebtn.addEventListener('click', function (event) {
                 event.preventDefault();
                 modal.style.display = 'none';
                 // videoIframe.src = ''; // Stop the video playback by clearing the src
              document.body.classList.remove("popup_open")
            });
        });
  }



const tab_click_all = document.querySelectorAll("[data-tabscroll-custom]");


    tab_click_all.forEach(b => {
    b.addEventListener("click", event => {
      event.preventDefault();
      const tragger_data = b.getAttribute("href") || null;
      console.log(tragger_data)
     const main_content =  document.querySelector(tragger_data) || null;
      console.log(main_content);

      if(main_content){
        smoothScrollTo(main_content, 100,10);
      }
    });
  });




            // Select the button using document.querySelector
var btn_scroll_top = document.querySelector('[data-top-scroll-custom]');

// Function to check the scroll position and show or hide the button
  if(btn_scroll_top){
function checkScroll() {
  if (window.scrollY > 300) {
    btn_scroll_top.classList.add('show');
  } else {
    btn_scroll_top.classList.remove('show');
  }
}

// Add the scroll event listener to the window
window.addEventListener('scroll', checkScroll);

// Function to smoothly scroll to the top when the button is clicked
btn_scroll_top.addEventListener('click', function(e) {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: 'smooth'  // Smooth scrolling
  });
});
  }
  


  
  
  
})();

const red_more_product = document.querySelector("[data-key-product]");
const red_more_product_toggal = document.querySelector("[data-toogle-key-feature]");
 const maindiscrption = document.querySelectorAll("[data-pdp-coll-content]") || null;
if (red_more_product && red_more_product_toggal) {
  if (!red_more_product.querySelectorAll('li').length > 3) red_more_product_toggal.setAttribute("hidden","");
  red_more_product_toggal.addEventListener("click",function(e) {
      e.preventDefault();
    // if(maindiscrption){
    //   console.log(maindiscrption[0]);
    //   maindiscrption[0].querySelector("button").click();
    // }
    smoothScrollTo(maindiscrption[0], 1000,400);
       red_more_product.classList.toggle("show_all_data");
    if(red_more_product.classList.contains('show_all_data')){
       red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-leass');
    }else{
      red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-more');
    }
    
    });
}else{
  if (red_more_product_toggal) {

      red_more_product_toggal.addEventListener("click",function(e) {
            e.preventDefault();
          // if(maindiscrption){
          //   console.log(maindiscrption[0]);
          //   maindiscrption[0].querySelector("button").click();
          // }
              smoothScrollTo(maindiscrption[0], 1000,400);
             red_more_product.classList.toggle("show_all_data");
          if(red_more_product.classList.contains('show_all_data')){
             red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-leass');
          }else{
            red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-more');
          }
          
          });
    
  }
}


const targetElement = document.querySelector('.your-element-selector');

function smoothScrollTo(element, duration,scroll_hight) {
    const targetPosition = element.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Limit to 1 (100%)
        const ease = easeInOutCubic(progress); // Easing function
        window.scrollTo(0, (startPosition + distance * ease) - scroll_hight);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    }

    function easeInOutCubic(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    requestAnimationFrame(animation);
}

// Example usage:


class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

 // <show-password>
 //   <a href="javascript:void(0);"class="close-icon">text</a>
 // </show-password>

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END


// Function to open the popup
function preorderpopup_open() {
  const popup = document.getElementById('product-addtocart-popup');
  if (popup) {
    popup.classList.add("preorderpopupopen"); 
    document.body.classList.add("popup_open"); 
  }
}

// Function to close the popup
function closePreorderPopup() {
  const popup = document.getElementById('product-addtocart-popup');
  if (popup) {
    popup.classList.remove("preorderpopupopen");
    document.body.classList.remove("popup_open");
  }
}



function closeEvent() {
const closePopup = document.querySelectorAll('[data-popup-closes]') || null;
if (closePopup) {
  closePopup.forEach(b => {
    b.addEventListener("click", event => {
      event.preventDefault();
      closePreorderPopup();
    });
  });
}
  const popupButton = document.querySelector('.popup-btn');
const popupCheckbox = document.querySelector('.popup-check');

if (popupButton && popupCheckbox) {
  popupButton.addEventListener('click', function() {
    closePreorderPopup(); 
    // if (popupCheckbox.checked) {
    //   closePreorderPopup(); 
    // }
  });
}
}
closeEvent();


const gbutton = document.querySelector(".gproduct_button");
console.log("gbutton",gbutton);
  if(gbutton){
     gbutton.addEventListener('click',() =>{
     const popup = document.querySelector(".gift-cart-products");
     console.log("popup",popup);
     popup.style.display = "block";
     });
}

class clickgiftbutton extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('button');
    facetLink.addEventListener('click', this.closepopup.bind(this));
  }

  closepopup(event) {
    event.preventDefault();
    console.log("button", document.querySelector('[data-gift-drawer]'));
    document.querySelector('.open[data-gift-drawer]').style.display = "block";
  }
}
customElements.define('click-gift-button', clickgiftbutton);

class closegiftbutton extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('button');
    facetLink.addEventListener('click', this.closepopup.bind(this));
  }

  closepopup(event) {
    event.preventDefault();
    this.closest('[data-gift-drawer]').style.display = "none";
  }
}

customElements.define('close-gift-button', closegiftbutton);

//Click btn-mehr scroll to desciptions
 let btn_mehr_erfahren = document.querySelector("[btn-mehr-erfahren]") || null;
  if(btn_mehr_erfahren){
      document.querySelector('.btn-mehr-erfahren').addEventListener('click', function(event) {
          event.preventDefault();
          
          const faqWrapper = document.querySelector('.pdp-faq-blog');
          
          if (faqWrapper) {
              const offsetTop = faqWrapper.getBoundingClientRect().top + window.pageYOffset - 100;
              window.scrollTo({ top: offsetTop, behavior: 'smooth' });
              
              const firstFaqItem = faqWrapper.querySelector('.faq__item');
              
              if (firstFaqItem) {
                  const collapsibleContent = firstFaqItem.querySelector('collapsible-content');
                  if (collapsibleContent && !collapsibleContent.hasAttribute('open')) {
                      collapsibleContent.setAttribute('open', '');
                      
                      const toggleButton = firstFaqItem.querySelector('.collapsible-toggle');
                      if (toggleButton) {
                          toggleButton.setAttribute('aria-expanded', 'true');
                      }
                  }
              }
          }
      });
  }

function newsletter_mail() {
const main_serch_parth = window.location.search.split("form_type=customer") || null;

if(main_serch_parth.length == 2){
  var mailText = document.querySelector('.alrady-email') || null;
  if(mailText){
    mailText.style.display = 'block';
    setTimeout(function(){
      window.history.replaceState({}, null, window.location.href.split('?')[0]); 
    },500);
  }
   
}
}


// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
      let hide_content = document.querySelectorAll("[data-host-port-content]");
    if(document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.contains('hidden')){
      hide_content.forEach(b => {
         b.classList.add("hidden");
      });
      document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.remove("hidden");
    }else{
      document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.add("hidden");
    }
  });        
}
let host_poart_link  = document.querySelectorAll("[data-hotsport-click]");
host_poart_link.forEach(hosport_click);
// hotsport end